<div class="sidebar-content">

    <div class="card">

        <!-- SIDEBAR HEADER -->
        <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">

            <!-- USER -->
            <span class="h2">{{'GESTORSTATUS.PRODSINFO.ADQUIRIDOS' | translate}}</span>
            <!-- / USER -->

        </div>
        <!-- / SIDEBAR HEADER -->

        <!-- SIDEBAR CONTENT -->
        <div class="content py-16" fusePerfectScrollbar>

            <div class="nav material2">
                <ng-container *ngFor="let producto of productosGenericos;">
                  <div class="nav-item">
                      <a class="nav-link" matRipple (click)="selProducto(producto.anio)"
                        [ngClass]="{'active accent':prodSelected === producto.anio}">
                          <span class="title">{{producto.anio}}</span>
                      </a>
                  </div>
                </ng-container>
            </div>

        </div>

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
